import MainLayout from 'components/layout/MainLayout';
import rewardsBackground from 'assets/images/backgrounds/base_final_reward.png';
import Stickers from './components/Stickers';
import { ButtonTypes } from 'types';

const StickerWall: React.FC = () => {
  return (
    <MainLayout
      backgroundImg={rewardsBackground}
      menuProps={{
        primaryLeftButton: { name: ButtonTypes.HOME_BUTTON },
      }}
      footerProps={{
        primaryRightButton: { name: ButtonTypes.ACCESSIBILITY_BUTTON },
      }}
    >
      <Stickers />
    </MainLayout>
  );
};

export default StickerWall;
